import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta as any).env.VITE_SUPABASE_URL;
const supabaseAnonKey = (import.meta as any).env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});

export interface UserProfile {
  id: string;
  master_password_hash: string;
  encryption_salt: string;
  created_at: string;
  updated_at: string;
}

export interface PasswordEntryDB {
  id: string;
  user_id: string;
  encrypted_data: string;
  category: string;
  iv: string;
  created_at: string;
  updated_at: string;
  version: number;
}

export interface SyncQueueDB {
  id: string;
  user_id: string;
  entry_id?: string;
  operation: 'create' | 'update' | 'delete';
  encrypted_data?: string;
  created_at: string;
  synced: boolean;
}
